import * as qs from "querystring";
import * as t from "io-ts";
import { fetchJSON } from "./fetchJSON";
const Observation = t.intersection([
    // t.dictionary(t.string, t.string),
    t.interface({
        id: t.string,
        value: t.number,
        location: t.string,
        date: t.string,
        facetId: t.string
    })
], "Observation");
const Slice = t.interface({
    id: t.string,
    observations: t.array(Observation)
}, "Slice");
/**
 * Transform API response into a more type-able structure.
 * We're using (d: any) -> any because we validate the result.
 *
 * **BEWARE**: There's no defensive coding in here. If a property doesn't
 * exist in the response, the whole transformation will blow up! This could
 * probably be done in a safer way (everything as Maybe?) but for now, errors
 * have to be caught somewhere else.
 */
const transformSlice = (slice) => {
    const id = slice["@id"];
    if (!slice.observation) {
        return {};
    }
    const observations = slice.observation.map((obs) => {
        const keys = Object.keys(obs);
        const measureKey = keys.find(k => /^m/.test(k)) || "mFOOBAR";
        const dimensionKeys = keys.filter(k => k !== "dRAUM" && k !== "dZEIT" && k !== "dataSet" && /^d/.test(k));
        const dimensionValues = dimensionKeys.reduce((values, k) => {
            values[k] = obs[k].replace("ssz-code:", "");
            return values;
        }, {});
        const updateEntries = Object.entries(obs).filter((k) => /^http/.test(k));
        const updateValues = updateEntries.map((v) => {
            let last = v[0].substring(v[0].lastIndexOf('/') + 1, v[0].length);
            return ({
                text: last,
                date: v[1]["@value"]
            });
        });
        return {
            id: obs["@id"],
            value: parseFloat(obs[measureKey]),
            location: obs.dRAUM.replace("ssz-code:", ""),
            date: obs.dZEIT["@value"],
            facetId: [
                measureKey.slice(1),
                ...Object.values(dimensionValues).sort()
            ].join("/"),
            ...dimensionValues,
            ...updateValues
        };
    });
    return {
        id,
        observations
    };
};
export const fetchSlice = ({ uri, ...params }) => fetchJSON({
    url: `${uri}?${qs.stringify(params)}`,
    decode: data => {
        const transformed = transformSlice(data);
        const decoded = Slice.decode(transformed);
        return decoded;
    }
});



// WEBPACK FOOTER //
// ./src/api/slice.ts